// "customer", "building" and "status" (a true/false shown as a green/red fill) are system columns supplied
// by the API; every other type can be chosen when a user adds a column.
export type ColumnType = "text" | "number" | "date" | "checkbox" | "select" | "customer" | "building" | "status" | "datetime";

export type UserColumnType = Exclude<ColumnType, "customer" | "building" | "status" | "datetime">;

export interface TrackingColumnDef {
  id: string; // field key in row data
  label: string;
  type: ColumnType;
  required: boolean; // required columns can't be removed
  predefined: boolean; // shipped with the page (vs. user-created)
  options?: string[] | null; // for "select" columns
  readonly?: boolean; // shown from the building but not editable here
}

export const COLUMN_TYPE_LABELS: Record<UserColumnType, string> = {
  text: "Text",
  number: "Number",
  date: "Date",
  checkbox: "Checkbox",
  select: "Dropdown",
};
